'use client';

import React, { useEffect, useRef } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

export default function XauPriceTicker() {
  const containerRef = useRef<HTMLDivElement>(null);
  const { t } = useLanguage();

  useEffect(() => {
    if (!containerRef?.current) return;

    // Clear any previous widget
    containerRef.current.innerHTML = '';

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js';
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = JSON.stringify({
      symbol: 'OANDA:XAUUSD',
      width: '100%',
      colorTheme: 'dark',
      isTransparent: true,
      locale: 'en',
    });

    containerRef?.current?.appendChild(script);
  }, []);

  return (
    <div className="w-full rounded-xl border border-white/5 bg-[#0e0e18] overflow-hidden">
      {/* Header bar */}
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-white/5 bg-[#0a0a14]">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
          <span className="text-xs font-mono text-zinc-400 tracking-widest uppercase">{t('livePrice')}</span>
        </div>
        <div className="flex items-center gap-1.5 px-2 py-0.5 rounded bg-emerald-500/10 border border-emerald-500/20">
          <span className="text-[10px] font-mono text-emerald-400 font-semibold tracking-widest">{t('live')}</span>
        </div>
      </div>

      {/* TradingView Single Quote Widget */}
      <div className="tradingview-widget-container" ref={containerRef} style={{ minHeight: '80px' }}>
        <div className="tradingview-widget-container__widget" />
      </div>
    </div>
  );
}
